import { render, staticRenderFns } from "./PaymentsOtrosPagos.vue?vue&type=template&id=25125144&scoped=true&"
import script from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"
export * from "./PaymentsOtrosPagos.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsOtrosPagos.vue?vue&type=style&index=0&id=25125144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25125144",
  null
  
)

export default component.exports